// extracted by mini-css-extract-plugin
module.exports = {"container":"Game_container__2ed6m","board":"Game_board__2l3t5"};